import PartyPackageCard from './PartyPackageCard';
import PartyPackageCardSkeleton from './PartyPackageCardSkeleton';
import hero from "./image/food-img.png";
import './PartyPackageListingPage.css';
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';

export default function VenuesListingPage() {

    const location = useLocation();
    const pathname = location.pathname;

    const segments = pathname.split('/').filter(Boolean);
    const pageSlug = segments[segments.length - 1];

    const pageName = pageSlug.replace(/-/g, ' ');


    const [data, setData] = useState([]);
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [keyword, setKeyword] = useState("");
    const [selectedMenuIds, setSelectedMenuIds] = useState([]);
    const [visibleCount, setVisibleCount] = useState(6);
    const loaderRef = useRef(null);

    const fetchData = (latitude, longitude, selectedMenuIds = []) => {
        const formData = new FormData();
        formData.append("latitude", latitude);
        formData.append("longitude", longitude);
        formData.append("venue_id", selectedMenuIds.join(","));
        formData.append("title_id", "");
        formData.append("keyword", keyword);

        axios
            .post(
                "https://partywitty.com/master/APIs/Common/allClubNew",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            )
            .then((response) => {
                if (response.data.status === true) {
                    setData(response.data.data);
                } else {
                    setData([]);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setLatitude(latitude.toString());
                    setLongitude(longitude.toString());
                    fetchData(latitude, longitude);
                },
                (error) => {
                    console.error("Error getting location:", error);
                }
            );
        } else {
            console.error("Geolocation is not available in this browser.");
        }
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisibleCount((prev) => prev + 6);
                }
            },
            { threshold: 1 }
        );

        if (loaderRef.current) {
            observer.observe(loaderRef.current);
        }

        return () => {
            if (loaderRef.current) observer.unobserve(loaderRef.current);
        };
    }, []);

    function generateClubUrl(clubName, cityName, areaName) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "_").toLowerCase() : "");

        console.log("format", `/${format(clubName)}-${format(cityName)}-${format(areaName)}`);

        return `/${format(clubName)}-${format(cityName)}-${format(areaName)}`;
    }

    return (
        <>
            <div className='party-package-list'>
                <div className="partypackage-hero-container">
                    <div className="partypackage-image-wrapper">
                        <img src={hero} alt="Event" className="partypackage-image" />
                        <div className="partypackage-overlay">
                            <div className="partypackage-title">
                                <h1>{pageName}</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='party-package-page-container'>
                    {data.length === 0 ? (
                        Array.from({ length: 6 }).map((_, index) => (
                            <PartyPackageCardSkeleton key={index} />
                        ))
                    ) : (
                        data.slice(0, visibleCount).map((item, index) => (
                            <Link
                                to={generateClubUrl(item.name, item.cityName, item.areaName)}
                                key={item.id}
                            >
                                <PartyPackageCard data={item} isListingPage={true} isVenueList={true} />
                            </Link>
                        ))

                    )}
                    <div ref={loaderRef} style={{ height: "1px" }} />
                </div>
            </div>
        </>
    );
}
